var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ship-layer-container"},[_c('div',{ref:"shipLayerContainer",staticClass:"ship-g6-layer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }